import EventsTabs from './components/EventsTabs';

export default function Events() {
  return (
    <div>
      <EventsTabs />
    </div>
  );
}
